<template>
  <div v-if="pageLoading" class="loading">
    <div class="mb-2">
      <img class="image" src="../assets/logo.png">
    </div>
    <div class="icon"><i class="far fa-2x fa-spin fa-spinner-third" :style="{'--fa-animation-duration': '400ms'}"></i></div>
    <div class="h5">لطفا منتظر باشید</div>
  </div>
  <RightSidenav></RightSidenav>
  <div class="page-wrapper">
    <TopBar></TopBar>
    <div class="page-content">

      <div class="container-fluid">
        <div v-if="pageTitle" class="row">
          <div class="col-sm-12">
            <div class="page-title-box">
              <div class="row">
                <div class="col">
                  <h4 class="page-title">{{pageTitle}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <slot/>
      </div>
    </div>
  </div>

</template>

<script>
import RightSidenav from "./RightSidenav";
import TopBar from "./TopBar";
import {mapGetters} from "vuex";
export default {
  name: "MasterLayout",
  components: {
    TopBar,
    RightSidenav
  },
  computed:{
    ...mapGetters('app',{
      pageTitle:'pageTitle',
      pageLoading:'pageLoading'
    })
  }

}
</script>

<style scoped>
.page-wrapper
{
  transition: 300ms;
}
.close_menu .page-wrapper {
  margin-right: 0;
  overflow: hidden;
}
.page-content
{
  position: relative;
}
.loading {
  position: fixed;
  width: 100%;
  height: 100%;
  right: 0;
  top: 0;
  left: 0;
  bottom: 0;
  background: #000000a8;
  z-index: 5;
  display: flex;
  text-align: center;
  justify-content:center ;
  flex-direction: column;
  color: white;
}
.loading .h5
{
  color: white;
}
</style>